export const baseUrlPartnerPortal = "http://35.208.65.24:3003";
//// export const baseUrl = "https://pmt-cloud.vastedge.com/api";
export const baseUrl = "/api";

export function buildQuery(query) {
  let queries = Object.keys(query).map((k) => `${k}=${query[k]}`);
  return `?${queries.join("&")}`;
}
